(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('MediaInternalController', MediaInternalController);

    /** @ngInject */
    function MediaInternalController($scope, $state, $stateParams, $rootScope, MediaService, AuthenticationService, HelperService, DATA_EVENTS) {
        const vm = this;

        vm.getNewsImage = () => {
            return HelperService.imageResizePath('news', vm.news.Id, vm.news.Image, 800, 400);
        }

        vm.onGalleryClick = $e => {
            $e.preventDefault();
        }

        vm.printDiv = function (divName) {
            var printContents = document.getElementById(divName).innerHTML;

            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
                var popupWin = window.open('', '_blank', 'width=600,height=600,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
                popupWin.window.focus();
                popupWin.document.write('<!DOCTYPE html><html><head>' +
                    '<link rel="stylesheet" href="/app/dist/styles/style.min.css?t=1553274462071" />' +
                    '</head><body onload="window.print()">' + printContents + '</body></html>');
                popupWin.onbeforeunload = function (event) {
                    popupWin.close();
                    return '.\n';
                };
                popupWin.onabort = function (event) {
                    popupWin.document.close();
                    popupWin.close();
                }
            } else {
                var popupWin = window.open('', '_blank', 'width=800,height=600');
                popupWin.document.open();
                popupWin.document.write('<html><head><link rel="stylesheet" href="/app/dist/styles/style.min.css?t=1553274462071" /></head><body onload="window.print()">' + printContents + '</body></html>');
                popupWin.document.close();
            }

            popupWin.document.close();

            return true;
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function recordPersonVisualization() {
            if (vm.news.HasPersonRead) return;

            let userData = AuthenticationService.getUserData();
            let accessLogData = {
                NewsId: vm.news.Id,
                PersonId: userData.Id
            }

            MediaService
                .postAccessLog(accessLogData);
        }

        function getNews() {
            HelperService.startLoading('.media-internal');

            vm.isLoading = true;

            let userData = AuthenticationService.getUserData();

            MediaService
                .getByUrl($stateParams.mediaUrl, userData.Id, userData.Responsibility.Id)
                .then(success => {
                    success.NewsGallery = success.NewsGallery
                        .reduce((acc, cur) => {
                            cur.fullPath = HelperService.imageHandlerPath('news', success.Id, cur.Image);

                            acc.push(cur);

                            return acc;
                        }, []);

                    vm.news = success;
                    vm.isLoading = false;

                    recordPersonVisualization();

                    HelperService.stopLoading('.media-internal');
                }, error => {
                    if ($stateParams.NewsId && $stateParams.NewsTitle) {
                        $state.go('app-master.default.news-internal', {
                            newsId: $stateParams.NewsId
                        });
                    } else
                        $state.go('app-master.default.media');

                    HelperService.errorCallback(error);
                })
        }

        function initVars() {
            vm.isLoading = false;
            vm.comments = [];
            vm.isLoadingComments = true;

            vm.breakpoints = {
                360: {
                    slidesPerView: 2,
                    spaceBetween: 5
                },
                500: {
                    slidesPerView: 3,
                    spaceBetween: 5
                },
                800: {
                    slidesPerView: 3,
                    spaceBetween: 5
                },
                1000: {
                    slidesPerView: 4,
                    spaceBetween: 5
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 5
                },
                2000: {
                    slidesPerView: 4,
                    spaceBetween: 5
                }
            }
        }

        function init() {
            initVars();
            getNews();
        }
    }
}());